// External Stuff
import React from 'react';

function About(props) {
	return (
		<div className='body-container'>
			<h1>About Page Heading!</h1>
            <h2>About Page Subheading</h2>
            <p>About Page Content Goes Here</p>
		</div>
	);
}

export default About;
